import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowDownLineOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M6.363 9.636 12 15.273l5.636-5.637-1.273-1.272-3.463 3.463V1h-1.8v10.827L7.636 8.364z"
                    fill="currentColor"
                />
                <path
                    d="M12 23C2.375 23 1 21.625 1 12h1.8c0 2.393.088 4.14.334 5.446.243 1.289.608 1.97 1.03 2.39.42.422 1.101.787 2.39 1.03 1.306.246 3.054.334 5.446.334s4.14-.088 5.446-.334c1.289-.243 1.97-.608 2.39-1.03.422-.42.787-1.101 1.03-2.39.246-1.306.334-3.054.334-5.446H23c0 9.625-1.375 11-11 11"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ArrowDownLineOutlinedSize24Glyph.displayName = 'ArrowDownLineOutlinedSize24Glyph';
